import { defineComponent as x, computed as z, createBlock as f, openBlock as v, unref as a, withCtx as i, createCommentVNode as y, createVNode as D, createTextVNode as s, toDisplayString as h } from "vue";
import "./highrise15.mjs";
import "./highrise8.mjs";
import I from "./highrise663.mjs";
import M from "./highrise96.mjs";
import N from "./highrise95.mjs";
import g from "./highrise155.mjs";
const O = /* @__PURE__ */ x({
  __name: "ModalFooter",
  props: {
    type: {
      type: String,
      default: "default"
    }
  },
  emits: ["left-click", "right-primary-click", "right-secondary-click"],
  setup(V) {
    const j = V, t = z(() => I[j.type]);
    return (p, o) => (v(), f(a(M), {
      id: "hr-modal-footer",
      size: "lg"
    }, {
      default: i(() => {
        var k, S, _, B, P, w;
        return [
          (S = (k = t.value) == null ? void 0 : k.leftButton) != null && S.show ? (v(), f(a(N), {
            key: 0,
            justify: "start"
          }, {
            default: i(() => {
              var l, n, u, m;
              return [
                D(a(g), {
                  id: "hr-modal-footer__left-button",
                  variant: (n = (l = t.value) == null ? void 0 : l.leftButton) == null ? void 0 : n.variant,
                  color: (m = (u = t.value) == null ? void 0 : u.leftButton) == null ? void 0 : m.color,
                  onClick: o[0] || (o[0] = (e) => p.$emit("left-click"))
                }, {
                  default: i(() => {
                    var e, c;
                    return [
                      s(h((c = (e = t.value) == null ? void 0 : e.leftButton) == null ? void 0 : c.label), 1)
                    ];
                  }),
                  _: 1
                }, 8, ["variant", "color"])
              ];
            }),
            _: 1
          })) : y("", !0),
          (B = (_ = t.value) == null ? void 0 : _.rightPrimary) != null && B.show || (w = (P = t.value) == null ? void 0 : P.rightSecondary) != null && w.show ? (v(), f(a(N), {
            key: 1,
            justify: "end"
          }, {
            default: i(() => {
              var l, n, u, m, e, c, C, $, b, F, H, L;
              return [
                (n = (l = t.value) == null ? void 0 : l.rightSecondary) != null && n.show ? (v(), f(a(g), {
                  key: 0,
                  id: "hr-modal-footer__right-secondary",
                  variant: (m = (u = t.value) == null ? void 0 : u.rightSecondary) == null ? void 0 : m.variant,
                  color: (c = (e = t.value) == null ? void 0 : e.rightSecondary) == null ? void 0 : c.color,
                  onClick: o[1] || (o[1] = (r) => p.$emit("right-secondary-click"))
                }, {
                  default: i(() => {
                    var r, d;
                    return [
                      s(h((d = (r = t.value) == null ? void 0 : r.rightSecondary) == null ? void 0 : d.label), 1)
                    ];
                  }),
                  _: 1
                }, 8, ["variant", "color"])) : y("", !0),
                ($ = (C = t.value) == null ? void 0 : C.rightPrimary) != null && $.show ? (v(), f(a(g), {
                  key: 1,
                  id: "hr-modal-footer__right-primary",
                  variant: (F = (b = t.value) == null ? void 0 : b.rightPrimary) == null ? void 0 : F.variant,
                  color: (L = (H = t.value) == null ? void 0 : H.rightPrimary) == null ? void 0 : L.color,
                  onClick: o[2] || (o[2] = (r) => p.$emit("right-primary-click"))
                }, {
                  default: i(() => {
                    var r, d;
                    return [
                      s(h((d = (r = t.value) == null ? void 0 : r.rightPrimary) == null ? void 0 : d.label), 1)
                    ];
                  }),
                  _: 1
                }, 8, ["variant", "color"])) : y("", !0)
              ];
            }),
            _: 1
          })) : y("", !0)
        ];
      }),
      _: 1
    }));
  }
});
export {
  O as default
};
